import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DrawEditor = _resolveComponent("DrawEditor")!
  const _component_AbstractExercise = _resolveComponent("AbstractExercise")!

  return (_openBlock(), _createBlock(_component_AbstractExercise, _mergeProps({ id: _ctx.elementId }, _ctx.$props), {
    submissionControls: _withCtx(() => [
      (_ctx.renderDrawEditor)
        ? (_openBlock(), _createBlock(_component_DrawEditor, {
            key: 0,
            onOnChange: _ctx.onChange,
            "initial-data": _ctx.initialData,
            style: {"height":"500px"}
          }, null, 8, ["onOnChange", "initial-data"]))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.answerImage,
            class: "show-only-in-thumbnail mt-2",
            style: {"width":"100%","height":"auto"}
          }, null, 8, _hoisted_1))
    ]),
    readOnlyAnswer: _withCtx(() => [
      _createElementVNode("img", { src: _ctx.answerImage }, null, 8, _hoisted_2)
    ]),
    _: 1
  }, 16, ["id"]))
}